import React from 'react'; 
import HeaderNav from '../components/HeaderNav';
import PageIntro from '../components/PageIntro';
import AboutPanels from '../components/AboutPanels';
import ClientPanels from '../components/ClientPanels';

function About() {


    return (
      <div id="mainContent">
        <div id="navHolder">
          <HeaderNav pageTitle="about" />
        </div>
        <div id = "intro">
            <h1>ABOUT</h1>
            <PageIntro pageTitle="About" output="intro"/>
        </div>
        <div id="aboutPanels" className="pagePanels">
            <AboutPanels />  
        </div>
        <div id="aboutClients" className="greyBkgd">
            <ClientPanels />
        </div>
      </div>
    );
  }
export default About;
